import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { BillingInformationService } from '@recruitee/billing-information';

import { readyOnce } from '../../../helpers/rx-operators';
import {
  PricingFeatureLoadedModel,
  PricingFeatureObservableModel,
} from '../../../types/pricing-feature.types';

@Injectable({
  providedIn: 'root',
})
export class ProductOrderPaymentStepGuard {
  constructor(
    private model$: PricingFeatureObservableModel,
    private store: Store,
    private actions$: Actions,
    private billingInformationService: BillingInformationService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.model$.pipe(
      readyOnce,
      switchMap((model: PricingFeatureLoadedModel) => {
        if (model.billingInformation) {
          return this.billingInformationService.validate(model.billingInformation);
        }

        return of(false);
      }),
    );
  }
}
